import type { ComponentType, MemoExoticComponent } from "react"
import { memo, useState } from "react"
import type { ErrorMessage } from "src/types/ErrorMessage"
import { ErrorHandlerContext } from "./ErrorHandlerContext"

export const withErrorHandler = <P extends object>(
	WrappedContainer: ComponentType<P>,
): MemoExoticComponent<ComponentType<P>> => {
	const Container = memo((props: any) => {
		const [error, setError] = useState<ErrorMessage>()
		return (
			<ErrorHandlerContext.Provider value={{ error, setError }}>
				<WrappedContainer {...props} />
			</ErrorHandlerContext.Provider>
		)
	})

	Container.displayName = WrappedContainer.displayName ?? WrappedContainer.name ?? "Container"
	return Container
}
